// El archivo JSX está correcto, asegúrate de que estás usando esta versión.
import React, { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../../../hooks";
import { VirtualScenes } from "../../../../api";
import { Grid, Header } from "semantic-ui-react";
import "./Module2.scss";

const virtualScenesController = new VirtualScenes();

export function Module2({ refId, onlyLeftColumn = false }) {
  const module2 = "module_02";
  const { accessToken } = useAuth();

  const [moduleData, setModuleData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ... (la lógica de fetch y useEffect no necesita cambios)
  const fetchModuleData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await virtualScenesController.getVirtualScenesModeule(
        refId,
        accessToken,
        module2
      );
      setModuleData(data.moduleData);
    } catch (err) {
      console.error("Error al obtener los datos del módulo:", err);
      setError("Error al cargar el módulo");
    } finally {
      setLoading(false);
    }
  }, [refId, accessToken, module2]);

  useEffect(() => {
    if (refId && accessToken) {
      fetchModuleData();
    }
  }, [refId, accessToken, fetchModuleData]);

  if (loading) return <div></div>;
  if (error) return <div>{error}</div>;

  const columnsNumber = onlyLeftColumn ? 1 : 2;
  const leftColumnWidth = onlyLeftColumn ? 16 : 8;

  return (
    <div className="module2-container">
      <Grid stackable columns={2} className="module2-grid">
        {/* Columna Izquierda */}
        <Grid.Column width={leftColumnWidth}>
          <div className="framed-box">
            <Header as="h2" className="block-title">
              {moduleData?.ModOneTitle || "VIRTUAL SCENE"}
            </Header>
            <div
              className="module2-description"
              dangerouslySetInnerHTML={{ __html: moduleData?.ModOneIntroduction || "" }}
            />
          </div>
        </Grid.Column>

        {/* Columna Derecha */}
        {!onlyLeftColumn && (
          <Grid.Column width={8}>
            <div className="framed-box">
              <Header as="h3" className="block-title">OBJETIVOS DIDÁCTICOS</Header>
              <div
                className="module2-objectives-list"
                dangerouslySetInnerHTML={{ __html: moduleData?.ModOneObjetives || "" }}
              />
              <Header as="h3" className="block-title">NIVEL</Header>
              <p className="module2-level">
                {moduleData?.ModOneLevels || "Sin niveles definidos"}
              </p>
            </div>
          </Grid.Column>
        )}
      </Grid>
    </div>
  );
}